<template>
  <input
    type="checkbox"
    class="form-checkbox appearance-none rounded-[4px] border-gpx_gray-600 outline-none ring-transparent checked:border-none checked:bg-gpx_terracotta-300 indeterminate:border-none indeterminate:bg-gpx_terracotta-300 hover:checked:bg-gpx_terracotta-200 indeterminate:hover:bg-gpx_terracotta-300 focus:ring-0 focus:checked:bg-gpx_terracotta-300 focus:hover:checked:bg-gpx_terracotta-200"
    :class="[
      { 'h-[16px] w-[16px]': size === 'small' },
      { 'h-5 w-5': size === 'large' },
    ]"
    :value="inputValue"
    v-model="model"
  />
</template>

<script>
export default {
  props: {
    inputValue: {
      type: [String, Number],
    },
    modelValue: {
      type: [Array, Boolean],
    },
    size: {
      type: String,
      validator(value) {
        return ['small', 'large'].includes(value);
      },
      default: 'small',
    },
  },

  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>
